module.exports = __webpack_public_path__ + "static/media/landing-tab-provider-management-d.0e8ddf96.svg";